import { TEAM } from "./constants";

const LinkedInIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M20.45 20.45h-3.55v-5.57c0-1.33-.03-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.36V9h3.41v1.56h.05c.48-.9 1.63-1.85 3.36-1.85 3.6 0 4.27 2.37 4.27 5.45v6.29zM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12zM7.12 20.45H3.56V9h3.56v11.45z" />
  </svg>
);

export const TeamSection = () => (
  <section id="team" className="team-section" data-testid="team-section">
    <div className="section-head reveal">
      <div className="section-eyebrow">Leadership</div>
      <h2 className="section-title">
        Meet Our <span className="gold">Team</span>
      </h2>
    </div>
    <div className="team-grid">
      {TEAM.map((m, i) => (
        <article
          className="team-card reveal"
          key={m.name}
          style={{ transitionDelay: `${i * 80}ms` }}
          data-testid={`team-${m.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
        >
          <div className="team-avatar" style={{ background: m.accent }}>
            <span>{m.initials}</span>
          </div>
          <div className="team-name">{m.name}</div>
          <div className="team-role">{m.role}</div>
          <p className="team-bio">{m.bio}</p>
          <div className="team-social">
            <a href="#" aria-label={`${m.name} on LinkedIn`} className="team-social-link" onClick={(e) => e.preventDefault()}>
              <LinkedInIcon />
            </a>
          </div>
        </article>
      ))}
    </div>
  </section>
);
